import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfigService } from '@core/infrastructure/config/config.service';
import { CorePlatformService } from '@core/infrastructure/platform/platform.service';

@Injectable()
export class AcceptanceService {
    private readonly origins = {
        NEWSLETTER: 58,
        CHECKOUT: 46,
        LOGIN: 5,
        GUEST_LOGIN: 6,
        SOCIAL_LOGIN: 141,
        REGISTRO: 10,
        COMING_SOON: 229,
        CONTACT: 608,
    };

    constructor(
        private readonly http: HttpClient,
        private readonly configService: ConfigService,
        private readonly platformService: CorePlatformService
    ) {}

    /**
     * Method that sends consent of "transferenciaforzosa" or/and "datossensibles"
     * @param string from
     * @param Array<string> types
     * @param string logonId
     * @param storeId Store Id
     */
    public consent(from: string, types: string[], logonId: string, storeId: string): Observable<boolean> {
        if (this.platformService.isBrowser()) {
            const normalizedFrom = from.toUpperCase();
            // biome-ignore lint/suspicious/noPrototypeBuiltins: <explanation>
            // biome-ignore lint/complexity/useSimplifiedLogicExpression: <explanation>
            if (!this.origins.hasOwnProperty(normalizedFrom)
             || !Array.isArray(types)
             || types.length < 1
             || logonId == null) {
                throwError(() => new Error('Incorrect parameters'));
            }
            const data = {
                idXoperation: this.origins[normalizedFrom],
                logonid: logonId,
                documentTypes: types,
            };

            const baseUrl = this.configService.getConfigUrl<string>('baseUrl');

            return this.http.post(`${baseUrl}/itxrest/2/user/store/${storeId}/documents/accept`, data).pipe(
                map(() => true)
            );
        }
    }
}
